import type { JSX } from 'solid-js';
import { t } from '../i18n';
import type { UtilBox } from '../lib/fleetUtilization';
import { type ResourceKind, resourceBar } from '../lib/machine-bars';
import { Tooltip } from './Tooltip';

// One of a Machines card's three bars (#6560, prototype `mini()`): the label and number
// over a thin bar, the whole of it the trigger of a `<Tooltip/>` saying what the number
// means. Presenter over `resourceBar` (`lib/machine-bars.ts`), which owns the number, the
// fill, the server's tier and the sentence. Colour never carries the tier alone: the
// number is beside it, and the verdict pill names the worst one.

export function MachineResourceBar(props: {
  readonly box: UtilBox;
  readonly kind: ResourceKind;
}): JSX.Element {
  const bar = () => resourceBar(props.box, props.kind, t);
  return (
    <Tooltip
      label={t('fleet.machines.bar_aria', { label: bar().label, value: bar().value })}
      text={bar().tip}
      alignEnd={props.kind === 'disk'}
      trigger={
        <span class="machine-bar" data-tone={bar().tone}>
          <span class="machine-bar__head">
            <span>{bar().label}</span>
            <span class="machine-bar__value">{bar().value}</span>
          </span>
          <span class="machine-bar__track">
            <span class="machine-bar__fill" style={{ width: `${bar().fill}%` }} />
          </span>
        </span>
      }
    />
  );
}
